/**
 * Mirror of `resume_pdf._sort_experiences` (Python). Keeps the CV editor
 * form and the printed PDF in the same order so the WYSIWYG lines up:
 *   1. Currently active rows (`current === true` OR blank `end`) first.
 *   2. Then most-recent start-date first (YYYY-MM).
 *   3. Tiebreaker: most-recent end-date first.
 *
 * JavaScript's `Array.prototype.sort` is stable (since ES2019), so rows
 * that share an identical sort key keep their original insertion order.
 */

const ymInt = (val) => {
  if (!val) return 0;
  const m = /^(\d{4})-(\d{1,2})$/.exec(String(val).trim());
  if (!m) return 0;
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  return y * 100 + mo;
};

export function sortExperiences(items) {
  if (!Array.isArray(items) || items.length < 2) return items || [];
  return [...items].sort((a, b) => {
    const aCurrent = Boolean(a.current) || !String(a.end || "").trim();
    const bCurrent = Boolean(b.current) || !String(b.end || "").trim();
    if (aCurrent !== bCurrent) return aCurrent ? -1 : 1;
    const aStart = ymInt(a.start);
    const bStart = ymInt(b.start);
    if (aStart !== bStart) return bStart - aStart;
    return ymInt(b.end) - ymInt(a.end);
  });
}
